// OTOMATİK ÇIKARILDI — kaynak: BeverageMachine
// src/communication/GSM/gsm-settings-getter.js (V2 grup fonksiyonları + label'lar).
//
// Rol şablonundaki "Ayarlar" sekmesi bu katalogdan beslenir: yönetici bir
// REFERANS CİHAZ seçmeden hangi ayarları görebileceğini/değiştirebileceğini
// seçer. Etiketler cihazın gönderdiği Türkçe label'lardır; "öğütücü" ibaresi
// panel kuralı gereği "değirmen" olarak yazılır (bkz. renameGrinderLabel).
//
// Bölüm bazlı yetkiler KALDIRILDI (2026-08-13): erişimin tek kaynağı bu
// katalogdan seçilen anahtarlardır. `devices.settings` yalnızca sekmeyi açar.
//
// Anahtar yolu sunucudaki süzgeçle birebir aynı olmalıdır
// (BayinerIOT-Server → modules/device/domain/device-setting-scope.js):
//   <group>.<key>            (profile.*, general.*, payment)
//   custom.<subgroup>.<key>  (Göz Ayarları — göz numarası yola girmez)
//
// Cihaz firmware'i yeni ayar eklerse buraya da eklenmeli; listede olmayan
// anahtar panelden seçilemez.
export const SETTING_KEY_CATALOG = [
  {
    group: "profile.security",
    label: "Güvenlik",
    keys: [
      { key: "userPassword", label: "Kullanıcı Şifresi" },
      { key: "adminPassword", label: "Admin Şifresi" },
      { key: "servicePassword", label: "Servis Şifresi" },
      { key: "developerPassword", label: "Geliştirici Şifresi" },
      { key: "auth", label: "Otomatik Giriş" },
    ],
  },
  {
    group: "profile.appearance",
    label: "Görünüm",
    keys: [
      { key: "bgColorChoose", label: "Arka Plan Rengi" },
      { key: "brigthness", label: "Ekran Parlaklığı" },
    ],
  },
  {
    group: "profile.settings",
    label: "Sistem",
    keys: [
      { key: "language", label: "Dil Seçeneği" },
      { key: "errorCode", label: "Hata Kodu" },
      { key: "operationMode", label: "Operasyon Modu" },
      { key: "uxcamEnabled", label: "Ekran Kayıt (UXCam)" },
      { key: "mqttLogActive", label: "MQTT Log Yayini" },
      { key: "mqttLogLevels", label: "MQTT Log Seviyeleri" },
      { key: "mqttLogCategories", label: "MQTT Log Kategorileri" },
      { key: "displayLogActive", label: "Ekran Log Yayını" },
      { key: "developerMode", label: "Geliştirici Modu (ADB)" },
    ],
  },
  {
    group: "profile.timeDate",
    label: "Saat & Tarih",
    keys: [
      { key: "isNetworkTimeEnabled", label: "Otomatik Saat" },
      { key: "isNetworkTimeZoneEnabled", label: "Otomatik Saat Dilimi" },
      { key: "is24HourFormatEnabled", label: "24 Saat Bicimi" },
      { key: "isLocaleDefaultEnabled", label: "Yerel Format" },
    ],
  },
  {
    group: "general.teaFilterCoffee",
    label: "Genel · Çay-Filtre Kahve Ortak",
    keys: [
      { key: "autoHeaterControlDegreeWithProgram", label: "Program Isıtıcı Süresi" },
      { key: "autoHeaterOpenInterval", label: "Isıtıcı Açılma Aralığı " },
      { key: "heatValue", label: "Çay-Filtre Kahve Sıcaklık" },
      { key: "brewWaterTransitionTime", label: "Demleme/Su Geçiş Süresi" },
      { key: "potTankVolume", label: "Çay-Filtre Kahve Su Tankı Hacmi" },
      { key: "massCalibrationThreshold", label: "Çay-Filtre Kahve Ağırlık Kalibrasyon Eşik Değeri" },
      { key: "waterTankPumpMode", label: "Çay-Filtre Kahve Su Çekme Modu" },
      { key: "waterTankActive", label: "Çay-Filtre Kahve Su Tankı" },
      { key: "drain", label: "Çay-Filtre Kahve Demlik Tahliye Süresi" },
      { key: "tankDrainValves", label: "Su Kazanı Tahliye Valfleri" },
      { key: "cleaning", label: "Çay-Filtre Kahve Demlik Temizlik Suyu Süresi" },
      { key: "cups", label: "Çay / Filtre Kahve Bardak Kayıtları" },
      { key: "hideBrewRatio", label: "Dem Oranını Gizle (Ana Ekran)" },
      { key: "hideProductGrams", label: "Ürün Gramajını Gizle" },
    ],
  },
  {
    group: "general.tea",
    label: "Genel · Çay",
    keys: [
      { key: "referenceCup", label: "Çay Referans Bardak Sayısı" },
      { key: "teaAbsurb", label: "Çay Emme Miktarı" },
      { key: "teaServiceValue", label: "Çay Servis Değeri" },
      { key: "teaBrewing", label: "Çay Demleme Süresi" },
      { key: "teaStaling", label: "Çay Bayatlama Süresi" },
      { key: "teaFirstWater", label: "Çay İlk Su Süresi" },
      { key: "teaContinueWater", label: "Çay Su Devam Süresi" },
      { key: "teaWaitingTime", label: "Çay Su Bekleme Süresi" },
      { key: "cleaningEndCounterTea", label: "Çay Temizlik Sayacı" },
      { key: "cleaningTimeTea", label: "Çay Temizlik Süresi" },
    ],
  },
  {
    group: "general.filterCoffee",
    label: "Genel · Filtre Kahve",
    keys: [
      { key: "filterAbsurb", label: "Filtre Kahve Emme Miktarı" },
      { key: "filterCoffeeServiceValue", label: "Filtre Kahve Servis Değeri" },
      { key: "filterCoffeeBrewing", label: "Filtre Kahve Demleme Süresi" },
      { key: "filterCoffeeStaling", label: "Filtre Kahve Bayatlama Süresi" },
      { key: "filterCoffeeFirstWater", label: "Filtre Kahve İlk Su Süresi" },
      { key: "filterCoffeeContinueWater", label: "Filtre Kahve Su Devam Süresi" },
      { key: "filterCoffeeWaitingTime", label: "Filtre Kahve Su Bekleme Süresi" },
      { key: "cleaningEndCounterFilterCoffee", label: "Filtre Kahve Temizlik Sayacı" },
      { key: "cleaningTimeFilterCoffee", label: "Filtre Kahve Temizlik Süresi" },
    ],
  },
  {
    group: "general.turkishCoffee",
    label: "Genel · Türk Kahvesi",
    keys: [
      { key: "tcWaterTankPumpMode", label: "Türk Kahvesi Su Çekme Modu" },
      { key: "editScope", label: "Düzenleme Kapsamı" },
      { key: "waterStorageFillingTimeMains", label: "Türk Kahvesi Şebeke Dolma Süresi" },
      { key: "waterStorageFillingTimeCarboy", label: "Türk Kahvesi Damacana Dolma Süresi" },
      { key: "defaultMill", label: "Türk Kahvesi Varsayılan Değirmen" },
      { key: "millTime", label: "Türk Kahvesi Değirmen Süreleri" },
      { key: "millTimeout", label: "Türk Kahvesi Değirmen Zaman Aşımı" },
      { key: "millWaitingTime", label: "Türk Kahvesi Değirmen Bekleme Süresi" },
      { key: "cleaningTemperature", label: "Türk Kahvesi Temizlik Sıcaklığı" },
      { key: "cleaningTimeTurkishCoffee", label: "Türk Kahvesi Temizlik Süresi (dk)" },
      { key: "cleaningEndCounterTurkishCoffee", label: "Türk Kahvesi Temizlik Sayacı" },
      { key: "grinder", label: "Türk Kahvesi Değirmen" },
      { key: "grinderSensorSensitivity", label: "Değirmen Sensörü Hassasiyeti" },
      { key: "autoCoffee", label: "Otomatik Kahve" },
      { key: "productSelection", label: "Ürün Seçimi" },
      { key: "autoCoffeeStartSec", label: "Otomatik Kahve Başlama Süresi (sn)" },
      { key: "defaultRevertTimeoutSec", label: "Varsayılan Ayara Geri Dönüş Süresi (sn)" },
      { key: "cupWithPlate", label: "Fincan Tabaklı" },
    ],
  },
  {
    group: "custom.teaFilterCoffee",
    label: "Göz · Çay-Filtre Kahve",
    keys: [
      { key: "brewLevel", label: "Dem Oranı (%)" },
      { key: "constantBrew", label: "Sabit Dem" },
      { key: "potCalibrationTime", label: "Çay-Filtre Kahve Demlik Kalibrasyon Değeri" },
      { key: "massScale", label: "Çay-Filtre Kahve Ağırlık Kalibrasyon Değeri" },
      { key: "autoBrewMassInTheAir", label: "Otomatik Havadaki Dem Ağırlığı" },
      { key: "autoWaterMassInTheAir", label: "Otomatik Havadaki Su Ağırlığı" },
    ],
  },
  {
    group: "custom.turkishCoffee",
    label: "Göz · Türk Kahvesi",
    keys: [
      { key: "cleaningWaterLevel", label: "Türk Kahvesi Temizlik Suyu Süresi" },
      { key: "hangerSensitivity", label: "Askı Sensörü Hassasiyeti" },
      { key: "cupSensorSensitivity", label: "Fincan Sensörü Hassasiyeti" },
      { key: "cupDisabled", label: "Türk Kahvesi Fincan Devre Dışı" },
      { key: "cupAlready", label: "Türk Kahvesi Fincan Yok Devam Et" },
      { key: "defaultPowerMode", label: "Türk Kahvesi Varsayılan Pişirme Modu" },
      { key: "defaultCup", label: "Türk Kahvesi Varsayılan Fincan" },
      { key: "waterLevel", label: "Su Seviyesi" },
      { key: "firstWater", label: "İlk Su oranı" },
      { key: "cookingTemperature", label: "Pişirme Sıcaklığı (°C)" },
      { key: "maxCookingTime", label: "Max Pişirme Süresi" },
      { key: "serviceDown", label: "Servis Aşağı" },
      { key: "halfPowerTemperature", label: "Yarı Güç (°C)" },
      { key: "halfPowerPercentage", label: "Yarı Güç Yüzdesi" },
      { key: "mixerSpeed", label: "Karıştırma Hızı" },
      { key: "firstMixerTime", label: "İlk Karıştırma Süresi" },
      { key: "halfPowerMixerRatio", label: "Yarı Güç Karıştırma Oranı" },
      { key: "autoMixer", label: "Otomatik Karıştırma" },
      { key: "autoMixerParams", label: "Otomatik Karıştırma Eğrisi" },
    ],
  },
  {
    group: "payment",
    label: "Ödeme",
    keys: [
      // #253: eski makinelerin qr / bayinerpay anahtarı sunucuda bunlarla
      // eşdeğer sayılır (device-setting-scope.js).
      { key: "bayinerpayQr", label: "BayinerPay QR" },
      { key: "bayinerpayNfc", label: "BayinerPay NFC" },
      { key: "turkishCoffeeSmallPrice", label: "Türk Kahvesi Fiyat" },
      { key: "teaBrewPrice", label: "Çay Fiyat" },
      { key: "filterCoffeeBrewPrice", label: "Filtre Kahve Fiyat" },
    ],
  },
]

/** Katalogdaki tüm anahtar yolları (tümünü seç için). */
/**
 * #253 — eski anahtar → yeni anahtar. Kayıtlı şablonlar toplu güncellenmez;
 * seçici eski anahtarı yeni karşılığıyla işaretli gösterir. Sunucu ikisini
 * eşdeğer sayar (device-setting-scope.js SETTING_KEY_ALIASES).
 */
export const LEGACY_SETTING_KEY_PATHS = Object.freeze({
  "payment.qr": "payment.bayinerpayQr",
  "payment.bayinerpay": "payment.bayinerpayNfc",
});

/** Anahtar listesindeki eski adları yeni adlarına çevirir (tekrarsız). */
export const normalizeSettingKeyPaths = (paths = []) => [
  ...new Set(paths.map((p) => LEGACY_SETTING_KEY_PATHS[p] || p)),
];

export const ALL_SETTING_KEY_PATHS = SETTING_KEY_CATALOG.flatMap((g) =>
  g.keys.map((k) => `${g.group}.${k.key}`),
);
